<template>
  <div class="modal" :class="{show}" @click="dismiss">
    <div class="modalContainer" @click="grabClick" :style="{width: width ? width + 'px' : undefined}">
      <div class="title" v-html="title"></div>
      <div class="subtitle" v-html="subtitle"></div>
      <div class="body">

        <slot/>

      </div>
      <div class="footer" :class="{single: actions.length === 1}">
        <button
          class="btn"
          :class="[(action.primary ? 'btn-primary' : 'btn-secondary')]"
          v-for="action of actions"
          :key="action.name"
          @click="callAction(action.action)">
          {{ action.name }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>

  import { ModalEventBus } from "./ModalEventBus";

  export default {

    name: "Modal",

    props: ["name", "title", "actions", "dismissable", "subtitle", "width"],

    data() {
      return {
        show: false
      }
    },

    beforeMount() {
      ModalEventBus.$on("toggle", this.handleToggle);
    },

    beforeDestroy() {
      ModalEventBus.$off("toggle", this.handleToggle);
    },

    methods: {
      handleToggle(name, state, data) {
        if (name != this.name) {
          return;
        }
        if (typeof state == "undefined") {
          this.show = !this.show;
        } else {
          this.show = state;
        }
      },
      callAction(action) {
        if (typeof action == "string") {
          if (action === "close") {
            this.show = false;
          }
        } else {
          action();
        }
      },
      dismiss() {
        if (typeof this.dismissable != "undefined") {
          this.show = false;
        }
      },
      grabClick(e) {
        e.stopPropagation();
      }
    }

  };

</script>

<style lang="scss" scoped>

  .modal {
    background-color: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(3px);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
    z-index: 1;
    &.show {
      opacity: 1;
      pointer-events: all;
      .modalContainer {
        top: 0;
      }
    }
  }
  .modalContainer {
    display: flex;
    flex-direction: column;
    padding: 32px;
    background-color: white;
    width: 400px;
    max-width: 100%;
    border-radius: 32px;
    position: relative;
    top: -40px;
    transition: top 0.3s ease;
    max-height: calc(100vh - 100px);

    p:first-child {
      margin-top: 0;
    }
    p:last-child {
      margin-bottom: 0;
    }
  }
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #404040;
  }
  .subtitle {
    margin-top: 2px;
    font-size: 14px;
    color: #808080;
    margin-bottom: 32px;
  }
  .body {
    overflow-x: hidden;
  }
  .footer {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    &.single {
      justify-content: center;
    }
    .btn-secondary {
      background-color: #f5f5f5;
    }
  }

</style>
